<template>
  <teleport to="body">
    <div v-if="visible" class="points-popup-overlay">
      <div class="points-popup-card">
        <div class="points-icon-wrapper">
          <i class="fa-solid fa-star animate-pulse"></i>
        </div>
        <h2 class="fw-bold mb-3 text-dark">¡Felicidades!</h2>
        <p class="points-earned-text mb-2 text-dark">Has ganado <span class="points-number">{{ points }}</span> puntos</p>
        <p class="points-sub-text mb-4 text-muted">Podrás canjearlos cuando quieras por recompensas exclusivas.</p>
        <div class="points-progress-bar"></div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'PointsEarnedPopup',
  props: {
    visible: Boolean,
    points: { type: Number, default: 0 }
  }
}
</script>

<style scoped>
.points-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11000;
  animation: fadeIn 0.3s ease;
}

.points-popup-card {
  background: white;
  padding: 40px;
  border-radius: 30px;
  text-align: center;
  max-width: 90%;
  width: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
  animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.points-icon-wrapper {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #FFD700, #FFA000);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  box-shadow: 0 10px 20px rgba(255, 160, 0, 0.4);
}

.points-icon-wrapper i {
  color: white;
  font-size: 40px;
}

.points-earned-text {
  font-size: 1.4rem;
  font-weight: 500;
}

.points-number {
  color: #FFA000;
  font-weight: 800;
  font-size: 2rem;
}

.points-sub-text {
  font-size: 0.95rem;
}

.points-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 6px;
  background: #FFA000;
  width: 100%;
  animation: progressDrain 5s linear forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

@keyframes progressDrain {
  from { width: 100%; }
  to { width: 0%; }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.animate-pulse {
  animation: pulse 2s infinite;
}
</style>
